import { useState } from 'react'
import { FEEDBACKS_ACTIONS } from '../context/feedbacks/FEEDBACKS_ACTIONS'
import { useFeedbacksContext } from '../context/feedbacks/FeedbacksProvider'
import FeedbackService from '../services/FeedbackService'

export default function useFeedbackActions() {
  const { feedbacksState, feedbacksDispatch } = useFeedbacksContext()
  const [inProgress, setInProgress] = useState(false)
  async function getQuestions() {
    try {
      feedbacksDispatch({
        type: FEEDBACKS_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await FeedbackService.getQuestions()
      feedbacksDispatch({
        type: FEEDBACKS_ACTIONS.SET_FEEDBACKS,
        payload: {
          questions: data.questions,
        },
      })
    } catch (error) {
      // The feedback widget is non-critical: swallow the error so a failed or
      // transient request doesn't crash the page with an uncaught rejection.
      console.error('Failed to load feedback questions:', error)
    } finally {
      feedbacksDispatch({
        type: FEEDBACKS_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  async function sendAnswer(payload) {
    try {
      setInProgress(true)
      const { data } = await FeedbackService.sendAnswer(payload)
      return data.message
    } catch (error) {
      throw error
    } finally {
      setInProgress(false)
    }
  }

  return { getQuestions, sendAnswer, inProgress }
}
